// extracted by mini-css-extract-plugin
export default {"sidebar":"WalletSidebar_sidebar__gp7dV"};